import { DietIdEnum } from '@front-activerse/common-components';
import type { dietSettings, stepConfigItem } from './types';

const stepsSchema: stepConfigItem[] = [
  { id: 'sex', slug: 'sex' },
  { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
  { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
  {
    id: 'weightValue',
    slug: 'weight',
    shouldBackendValidate: true,
  },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'activityLevel',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: dietSettings) =>
                state.dietType === DietIdEnum.DIET_ID_GLP1 ||
                state.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC ||
                state.dietType === DietIdEnum.DIET_ID_GLP1_FRIENDLY
                  ? 'dietLevel'
                  : 'summary',
              children: {
                dietLevel: [
                  { id: 'dietLevel', slug: 'diet-level' },
                  { id: 'summary', slug: 'summary' },
                ],
                summary: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
        activityLevel: [
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: dietSettings) =>
                state.dietType === DietIdEnum.DIET_ID_GLP1 ||
                state.dietType === DietIdEnum.DIET_ID_GLP1_CLASSIC ||
                state.dietType === DietIdEnum.DIET_ID_GLP1_FRIENDLY
                  ? 'dietLevel'
                  : 'summary',
              children: {
                dietLevel: [
                  { id: 'dietLevel', slug: 'diet-level' },
                  { id: 'summary', slug: 'summary' },
                ],
                summary: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
      },
    },
  },
];

export default stepsSchema;
